import { Flame, Plus } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

// Compact horizontal rail of the products this employee orders most often.
export default function TodayPriorityRail({ items, supplierById, onAdd }) {
  const { t } = useLanguage();
  if (!items || items.length === 0) return null;
  return (
    <section className="mb-6" data-testid="today-priority-rail">
      <div className="flex items-center gap-2 mb-2">
        <Flame size={16} className="text-[#F07C52]" />
        <h2 className="font-serif-display text-2xl">{t("priorities")}</h2>
        <span className="text-[10px] tracking-eyebrow uppercase text-[#0B1F3A]/55 ml-1">
          {t("auto")}
        </span>
      </div>
      <p className="text-xs text-[#0B1F3A]/60 mb-3 max-w-xl">
        {t("priorityHelp")}
      </p>
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
        {items.map(({ product, orderCount, lastRequestedAt }) => {
          const supplier = supplierById(product.supplierId);
          const lastOrdered = lastRequestedAt
            ? new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(lastRequestedAt))
            : t("never");
          return (
            <div
              key={product.id}
              data-testid={`priority-card-${product.id}`}
              className="shrink-0 w-56 bg-white border border-[#E6E0D4] rounded-xl overflow-hidden hover:border-[#0B1F3A]/25 transition-colors"
            >
              <div className="aspect-[16/10] bg-[#F3EFE7] relative">
                {product.image ? (
                  <img
                    src={product.image}
                    alt=""
                    className="h-full w-full object-contain object-center"
                    loading="lazy"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                  />
                ) : null}
                <div className="absolute top-1.5 left-1.5">
                  <span className="text-[10px] tracking-eyebrow uppercase bg-white/90 backdrop-blur border border-[#E6E0D4] rounded-full px-2 py-0.5 text-[#0B1F3A]/70">
                    {t("lastOrdered", { date: lastOrdered })}
                  </span>
                </div>
              </div>
              <div className="p-2.5">
                <p className="text-sm font-medium leading-snug line-clamp-2 min-h-[2.5em]">
                  {product.name}
                </p>
                <p className="text-[11px] text-[#0B1F3A]/55 mt-1 truncate">
                  {supplier?.name || "—"} · {t("orderedCount", { count: orderCount })}
                </p>
                <button
                  type="button"
                  data-testid={`priority-add-${product.id}`}
                  onClick={() => onAdd(product.id)}
                  className="mt-2 w-full h-8 rounded-md bg-[#0B1F3A] hover:bg-[#11294A] text-white text-xs font-medium flex items-center justify-center gap-1 transition-colors"
                >
                  <Plus size={12} />
                  {t("addList")}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
